import { PatientInsurance } from "pwapi";

import { shallowLeftDiff } from "shared/utils/formUtils";

export const initialValuesForPatientInsurance = (
  insurance: PatientInsurance
): PatientInsurance => {
  // TODO: refactor this `setInitialValues` and type it properly
  // A simpler spread function would work better here and be more readable
  // Additionally, the `any` types break the inferred return value
  const setInitialValues = (emptyObject: any, initializingObject: any) => {
    return Object.keys(emptyObject).reduce((acc: any, key: string) => {
      key === "primary_provider"
        ? (acc[key] = !!initializingObject.primary_provider)
        : (acc[key] =
            key === "relationship_to_patient" &&
            initializingObject[key] === "SEL"
              ? "SELF"
              : initializingObject[key] || undefined);
      return acc;
    }, emptyObject);
  };

  return setInitialValues(
    {
      policy_number: "",
      group_employer_id: "",
      relationship_to_patient: "",
      insured_last_name: "",
      insured_first_name: "",
      insured_date_of_birth: "",
      insurance_company_name: "",
      insurance_company_state: "",
      insurance_company_city: "",
      insurance_company_zipcode: "",
      insurance_company_address: "",
      insurance_company_address2: "",
      primary_provider: false,
      plan: undefined,
      has_abn: false,
      preapproval_id: "",
    },
    insurance
  );
};

export const submissionFieldsForPatientInsurance = (
  insurance: PatientInsurance,
  isManual: boolean,
  values?: Partial<PatientInsurance>
) => {
  if (!values) values = initialValuesForPatientInsurance(insurance);

  const userInfo =
    values.relationship_to_patient === "SELF"
      ? { relationship_to_patient: "SELF" }
      : {
          relationship_to_patient: values.relationship_to_patient || null,
          insured_first_name: values.insured_first_name || null,
          insured_last_name: values.insured_last_name || null,
          insured_date_of_birth: values.insured_date_of_birth || null,
        };

  const insuranceCompanyDetails = isManual
    ? {
        insurance_company_name: values.insurance_company_name || null,
        insurance_company_state: values.insurance_company_state || null,
        insurance_company_city: values.insurance_company_city || null,
        insurance_company_zipcode: values.insurance_company_zipcode || null,
        insurance_company_address: values.insurance_company_address || null,
        insurance_company_address2: values.insurance_company_address2 || null,
      }
    : {
        plan: values.plan?.id ? { id: values.plan.id } : null,
      };

  return {
    ...userInfo,
    ...insuranceCompanyDetails,
    primary_provider: values.primary_provider || false,
    has_abn: values.has_abn || false,
    preapproval_id: values.preapproval_id || null,
    policy_number: values.policy_number || null,
    group_employer_id: values.group_employer_id || null,
  };
};

export const shallowPatientInsuranceComparison = (
  insurance: PatientInsurance,
  values: Partial<PatientInsurance>,
  isManual: boolean
) => {
  const oldValues = submissionFieldsForPatientInsurance(insurance, isManual);
  const newValues = submissionFieldsForPatientInsurance(
    insurance,
    isManual,
    values
  );

  return shallowLeftDiff<
    ReturnType<typeof submissionFieldsForPatientInsurance>
  >(oldValues, newValues);
};
